// extracted by mini-css-extract-plugin
module.exports = {"root":"hjWOx5io","spacer":"o6Hqxao2","clearAll":"Kyt9Ifb9"};